import React, { forwardRef, useRef } from "react";
import swal from "sweetalert";
import { DeleteOutline, Edit } from "@material-ui/icons";
import { Button } from "../../../components/CustomControl/Button";

import CustomTable from "components/CustomTable/CustomTable";
import {
  apiCall,
  apiOption,
  LoginUserInfo,
  language,
} from "../../../actions/api";
import ExecuteQueryHook from "../../../components/hooks/ExecuteQueryHook";

import {
  Typography,
  Paper,
  Grid,
  Input,
  makeStyles,
  CircularProgress,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    // minHeight: "100vh",
    // backgroundColor: "#f5f5f5",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // padding: theme.spacing(2),
    padding: "10px",
  },
  paper: {
    padding: theme.spacing(4),
    maxWidth: "50%",
    width: "100%",
  },
  // input: {
  //   marginTop: theme.spacing(2),
  //   marginBottom: theme.spacing(1),
  // }
}));
const InvoiceUpload = (props) => {
  const serverpage = "invoiceupload"; // this is .php server page

  const permissionType = props.permissionType;
  const { useState } = React;
  const [bFirst, setBFirst] = useState(true);
  // const [currentRow, setCurrentRow] = useState([]);
  // const [showModal, setShowModal] = useState(false); //true=show modal, false=hide modal

  const { isLoading, data: dataList, error, ExecuteQuery } = ExecuteQueryHook(); //Fetch data
  const UserInfo = LoginUserInfo();

  const classes = useStyles();
  const [selectedFile, setSelectedFile] = useState(null);
  // const [uploadStatus, setUploadStatus] = useState("");
  const [toggleShowTable, setToggleShowTable] = useState(false);
  const [loading, setLoading] = useState(false);
  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  // const PrintPDFExcelExportFunction = () => {
  //   let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";

  //   window.open(
  //     finalUrl +
  //       "?action=CheckListExport" +
  //       "&reportType=excel" +
  //       "&ClientId=" +
  //       UserInfo.ClientId +
  //       "&BranchId=" +
  //       UserInfo.BranchId +
  //       "&TimeStamp=" +
  //       Date.now()
  //   );
  // };
  /* =====End of Excel Export Code==== */

  const columnList = [
    {
      field: "rownumber",
      label: "SL",
      align: "center",
      width: "5%",
    },
    {
      field: "Name",
      label: "Name",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "BusinessUnit",
      label: "Business Unit",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "BudgetCode",
      label: "Budget Code",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "AccountCode",
      label: "Customer Code",
      align: "left",
      visible: true,
      sort: false,
      filter: true,
    },
    {
      field: "AccountingPeriod",
      label: "Invoice Month",
      align: "left",
      visible: true,
      sort: false,
      filter: true,
    },
    {
      field: "DebitCredit",
      label: "Debit Credit",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "Description",
      label: "Description",
      align: "left",
      visible: true,
      sort: false,
      filter: true,
    },
    {
      field: "JournalType",
      label: "Journal Type",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "BaseAmount",
      label: "Invoice Amount (BDT)",
      align: "right",
      visible: true,
      sort: false,
      filter: true,
      type: "number",
    },
        {
      field: "BaseAmountWithoutVat",
      label: "Amount (BDT)",
      align: "right",
      visible: true,
      sort: false,
      filter: true,
      type: "number",
    },
    {
      field: "VatAmount",
      label: "VAT (BDT)",
      align: "right",
      visible: true,
      sort: false,
      filter: true,
      type: "number",
    },
    {
      field: "TransactionDate",
      label: "Invoice Date",
      align: "left",
      visible: true,
      sort: false,
      filter: true,
    },
    {
      field: "TransactionReference",
      label: "Invoice No",
      align: "left",
      visible: true,
      sort: false,
      filter: true,
    },
    {
      field: "AnalysisCode1",
      label: "Analysis Code 1",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "AnalysisCode2",
      label: "Analysis Code 2",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "AnalysisCode3",
      label: "Business Line",
      align: "left",
      visible: true,
      sort: false,
      filter: true,
    },
    {
      field: "AnalysisCode4",
      label: "Analysis Code 4",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "AnalysisCode5",
      label: "Analysis Code 5",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "AnalysisCode6",
      label: "Analysis Code 6",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "AnalysisCode7",
      label: "Analysis Code 7",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "AnalysisCode8",
      label: "Analysis Code 8",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "AnalysisCode9",
      label: "Analysis Code 9",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "TransactionAmount",
      label: "Amount (USD)",
      align: "left",
      visible: true,
      sort: false,
      filter: true,
      type: "number",
    },
    {
      field: "CurrencyCode",
      label: "Currency Code",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "GeneralDate1",
      label: "General Date 1",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "GeneralDate2",
      label: "General Date 2",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "GeneralDate3",
      label: "General Date 3",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "GeneralDescription9",
      label: "Report No",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "GeneralDescription4",
      label: "General Description 4",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "GeneralDescription11",
      label: "Buyer Name",
      align: "left",
      visible: true,
      sort: false,
      filter: true,
    },
    {
      field: "GeneralDescription2",
      label: "General Description 2",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "GeneralDescription12",
      label: "General Description 12",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "GeneralDescription13",
      label: "General Description 13",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "GeneralDescription14",
      label: "Merchant Name",
      align: "left",
      visible: true,
      sort: false,
      filter: true,
    },
    {
      field: "GeneralDescription15",
      label: "General Description 15",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "GeneralDescription16",
      label: "General Description 16",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "GeneralDescription17",
      label: "Style Name",
      align: "left",
      visible: true,
      sort: false,
      filter: true,
    },
    {
      field: "GeneralDescription18",
      label: "PI No",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "GeneralDescription19",
      label: "General Description 19",
      align: "left",
      visible: false,
      sort: false,
      filter: true,
    },
    {
      field: "GeneralDescription20",
      label: "Service",
      align: "left",
      visible: true,
      sort: false,
      filter: true,
    },
    {
      field: "CustomerUserName",
      label: "Assigned Staff",
      align: "left",
      visible: true,
      sort: false,
      filter: true,
    },
  ];
  if (bFirst) {
    /**First time call for datalist */
    // getDataList();
    setBFirst(false);
  }

  /**Get data for table list */
  function getDataList(pInvoiceId) {
    let params = {
      action: "getDataList",
      lan: language(),
      UserId: UserInfo.UserId,
      InvoiceId: pInvoiceId,
    };
    // console.log('LoginUserInfo params: ', params);

    ExecuteQuery(serverpage, params);
  }

  /** Action from table row buttons*/
  // function actioncontrol(rowData) {
  //   return (
  //     <>
  //       {permissionType === 0 && (
  //         <Edit
  //           className={"table-edit-icon"}
  //           onClick={() => {
  //             editData(rowData);
  //           }}
  //         />
  //       )}

  //       {permissionType === 0 && (
  //         <DeleteOutline
  //           className={"table-delete-icon"}
  //           onClick={() => {
  //             deleteData(rowData);
  //           }}
  //         />
  //       )}
  //     </>
  //   );
  // }

  // const addData = () => {
  //   // console.log("rowData: ", rowData);
  //   // console.log("dataList: ", dataList);

  //   setCurrentRow({
  //     id: "",
  //     CheckName: "",
  //   });
  //   openModal();
  // };

  // const editData = (rowData) => {
  //   // console.log("rowData: ", rowData);
  //   // console.log("dataList: ", dataList);

  //   setCurrentRow(rowData);
  //   openModal();
  // };

  // function openModal() {
  //   setShowModal(true); //true=modal show, false=modal hide
  // }

  // function modalCallback(response) {
  //   //response = close, addedit
  //   // console.log('response: ', response);
  //   getDataList();
  //   setShowModal(false); //true=modal show, false=modal hide
  // }

  // const deleteData = (rowData) => {
  //   swal({
  //     title: "Are you sure?",
  //     text: "Once deleted, you will not be able to recover this data!",
  //     icon: "warning",
  //     buttons: {
  //       confirm: {
  //         text: "Yes",
  //         value: true,
  //         visible: true,
  //         className: "",
  //         closeModal: true,
  //       },
  //       cancel: {
  //         text: "No",
  //         value: null,
  //         visible: true,
  //         className: "",
  //         closeModal: true,
  //       },
  //     },
  //     dangerMode: true,
  //   }).then((allowAction) => {
  //     if (allowAction) {
  //       deleteApi(rowData);
  //     }
  //   });
  // };

  // function deleteApi(rowData) {
  //   let params = {
  //     action: "deleteData",
  //     lan: language(),
  //     UserId: UserInfo.UserId,
  //     ClientId: UserInfo.ClientId,
  //     BranchId: UserInfo.BranchId,
  //     rowData: rowData,
  //   };

  //   // apiCall.post("productgroup", { params }, apiOption()).then((res) => {
  //   apiCall.post(serverpage, { params }, apiOption()).then((res) => {
  //     // console.log('res: ', res);
  //     props.openNoticeModal({
  //       isOpen: true,
  //       msg: res.data.message,
  //       msgtype: res.data.success,
  //     });
  //     getDataList();
  //   });
  // }

  // const handleFileChange = (e) => {
  //   setSelectedFile(e.target.files[0]);
  //   setUploadStatus("");
  // };

  const handleFileChange = (e) => {
    // setUploadStatus("");
    let file = e.target.files[0];
    if (file) {
      // let data = { ...currentRow };
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        // data['CoverFileUrlUpload'] = event.target.result;
        setSelectedFile(event.target.result);
      };
    }
  };

  // const handleUpload = () => {
  //   console.log('selectedFile: ', selectedFile);
  //   if (!selectedFile) {
  //     setUploadStatus("⚠️ Please select a file.");
  //     return;
  //   }
  //   setUploadStatus(`✅ File "${selectedFile.name}" uploaded successfully!`);
  // };

  function handleUpload() {
    // if (validateForm()) {

    //     console.log('currentRow: ', currentRow);
    if (selectedFile) {
      let params = {
        action: "dataAddEdit",
        lan: language(),
        UserId: UserInfo.UserId,
        ClientId: UserInfo.ClientId,
        BranchId: UserInfo.BranchId,
        rowData: selectedFile,
      };

      setLoading(true); //Show loader
      apiCall.post(serverpage, { params }, apiOption()).then((res) => {
        props.openNoticeModal({
          isOpen: true,
          msg: res.data.message,
          msgtype: res.data.success,
        });

        if (res.data.success === 1) {
          setToggleShowTable(true);
          setLoading(false); //Hide loader
          getDataList(res.data.InvoiceId);
        }
      });
    } else {
      props.openNoticeModal({
        isOpen: true,
        msg: "Please select file",
        msgtype: 0,
      });
    }
  }
  function uploadAnotherFile() {
    setToggleShowTable(false);
    setSelectedFile(null);
  }

  return (
    <>
      <div class="bodyContainer">
        {/* <!-- ######-----TOP HEADER-----####### --> */}
        <div class="topHeader">
          <h4>
            <a href="#">Home</a> ❯ Invoice ❯ Invoice Upload
          </h4>
        </div>

        {/* <!-- TABLE SEARCH AND GROUP ADD --> */}
        {/* <div class="searchAdd">
          <Button
            label={"Export"}
            class={"btnPrint"}
            onClick={PrintPDFExcelExportFunction}
          />
          <Button
            disabled={permissionType}
            label={"ADD"}
            class={"btnAdd"}
            onClick={addData}
          />
        </div> */}

        {!toggleShowTable && (
          <div className={classes.root}>
            <Paper className={classes.paper} elevation={3}>
              <Typography variant="h5" align="center" gutterBottom>
                Upload a File (.xlsx, .xls)
              </Typography>

              <Input
                type="file"
                accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                onChange={(e) => handleFileChange(e)}
                fullWidth
                className={classes.input}
                inputProps={{
                  style: {
                    // padding: "12px 8px", // vertical padding increases height
                    height: "100px",
                  },
                }}
              />

              <Grid container justify="center">
                {loading && (
                  <div style={{ textAlign: "center", marginTop: "5px" }}>
                    <CircularProgress size={24} />
                  </div>
                )}

                <Button
                  disabled={loading}
                  label={"Invoice Upload"}
                  class={"btnAdd"}
                  onClick={handleUpload}
                />
              </Grid>
            </Paper>
          </div>
        )}

        {/* <!-- ####---THIS CLASS IS USE FOR TABLE GRID PRODUCT INFORMATION---####s --> */}

        {toggleShowTable && (
          <div>
            <div style={{ textAlign: "center !important" }} class="searchAdd">
              <div
                style={{
                  marginBottom: "4px",
                  width: "45%",
                  fontWeight: "bold",
                }}
              >
                Total Uploaded Invoice: {dataList.length}
              </div>

              <Button
                label={"Upload Another File"}
                class={"btnPrint"}
                onClick={uploadAnotherFile}
              />
            </div>

            {/* <div class="subContainer tableHeight">
              <div className="App"> */}
            <CustomTable
              columns={columnList}
              rows={dataList ? dataList : {}}
              // actioncontrol={actioncontrol}
            />
            {/* </div>
            </div> */}
          </div>
        )}
      </div>
      {/* <!-- BODY CONTAINER END --> */}
    </>
  );
};

export default InvoiceUpload;
